import createAPI from './hotel-api';

const credentialsConf = {
  withCredentials: true,
  validateStatus: () => true,
};

const api = createAPI(process.env.MUJI_APP_HOST, {
  showNotification: true,
});

export function queryTrafficStat(params){
    return api.getJson(`/portal/api/v2/stat/traffic`, params, credentialsConf);
}


